const getIssueLink = (id: string) => {
	return `https://support.ics-it.ru/issue/${id}`;
};

export default getIssueLink;
